import { ConvertGoalType } from '../convert/ConvertGoalType';
import { getConvertTrackMethod } from '../convert/getConvertTrackMethod';
import { trackGoogleAnalyticsPageView } from './trackGoogleAnalyticsPageView';
export const trackGoogleAnalyticsAndConvertGoal = () => {
  trackGoogleAnalyticsPageView();
  const trackSignupCompletedConvertGoal = getConvertTrackMethod(ConvertGoalType.SignupCompleted);
  if (trackSignupCompletedConvertGoal) {
    trackSignupCompletedConvertGoal();
  }
};